import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { OiTab } from '../types';
import { InitOutput } from 'parquet-wasm';

const { persistAtom } = recoilPersist();

export const oiSymsState = atom<Set<string>>({
  key: 'oi-syms',
  default: new Set(),
});

export const oiTabState = atom<OiTab>({
  key: 'oi-tab',
  default: OiTab.DAILY_OI,
  effects_UNSTABLE: [persistAtom],
});

export const parquetWasmInitPromise = atom<Promise<InitOutput> | null>({
  key: 'parquet-wasm-init-promise',
  default: null,
});

export const oiLatestServerTsMapState = atom<Map<string, number>>({
  key: 'oi-latest-server-ts-map-state',
  default: new Map(),
});
